import { apiFetch } from '@ami/react/core';
import MachineMakeFilter from '../machines/machineMakeFilter';

const _baseEndPoint = 'machines';

export class MachineMake {
  constructor(item) {
    if (item) {
      this.name = item.name;
      return;
    }
    this.name = null;
  }

  static async search(filter = new MachineMakeFilter(), page) {
    filter.setPaginationParameters(page);
    const entities = await apiFetch(
      `${_baseEndPoint}/manufacturers?${filter.toQueryString()}`
    );
    return entities.map((x) => new MachineMake(x));
  }
}
